import { Button, Typography } from '@mui/material';
import { GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid-premium';
import {
  buttonTypography,
  exportButtonProps
} from 'components/enhanced/data-grid/components/toolbar/EnhancedToolbar';
import { useTranslation } from 'react-i18next';

interface ExportProps {
  purchaseRequestId?: number | string;
}

function ExportButtonToolbar(props: ExportProps) {
  const { purchaseRequestId } = props;
  const { t } = useTranslation();

  const apiRef = useGridApiContext(); // Ottieni il riferimento all'API della griglia

  const handleExportExcel = () => {
    const visibleColumns = apiRef.current.getVisibleColumns();
    const filteredColumns = visibleColumns.filter((col) => col.field !== 'actions');

    apiRef.current.exportDataAsExcel({
      fileName: `dettagli_movimento_${purchaseRequestId}`,
      fields: filteredColumns.map((col) => col.field)
    });
  };

  return (
    <GridToolbarContainer className="flex justify-end pb-2">
      <Button
        {...exportButtonProps}
        onClick={handleExportExcel} // Chiama l'esportazione Excel
      >
        <Typography {...buttonTypography}>{t('actions.export')}</Typography>
      </Button>
    </GridToolbarContainer>
  );
}

export default ExportButtonToolbar;
